var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    _vm.guidePageShow
      ? _c("div", { key: "openApp", staticClass: "open-in-browser" }, [
          _vm._m(0)
        ])
      : _c(
          "div",
          { staticClass: "loading" },
          [_c("van-loading", { attrs: { size: "48" } })],
          1
        )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "main-content clearfix" }, [
      _c("div", { staticClass: "arrow" }),
      _vm._v(" "),
      _c("div", { staticClass: "list" }, [
        _c("p", { staticClass: "hint" }, [
          _vm._v("1、点击右上角的"),
          _c("img", {
            attrs: {
              src: require("@/assets/images/three-dot.png"),
              width: "20px"
            }
          }),
          _vm._v("按钮")
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "hint" }, [
          _vm._v("2、选择"),
          _c("img", {
            attrs: {
              src: require("@/assets/images/open-in-browser.png"),
              height: "24px"
            }
          })
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }